import type { SxProps, Theme } from "@mui/material";
import { styled } from "@mui/material";

export const square = {
  aspectRatio: "1 / 1",
  maxHeight: "100%",
  maxWidth: "100%",
  overflow: "hidden",
} as const satisfies SxProps<Theme>;

export const Square = styled("div")(square);
